import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginUser, resendVerification } from '../API';

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [unverifiedHint, setUnverifiedHint] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState('');

  const handleResend = async () => {
    setResendMessage('');
    setResendLoading(true);

    try {
      const response = await resendVerification({ email: username });
      setResendMessage(response.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setResendLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setUnverifiedHint(false);
    setResendMessage('');
    setLoading(true);

    try {
      await loginUser({ username, password });
      navigate('/');
    } catch (err) {
      setError(err.message);
      if (err.code === 'EMAIL_NOT_VERIFIED') {
        setUnverifiedHint(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container pt-4">
      <div className="container-fluid col-sm-8 col-lg-6">
        <div className="jumbotron mt-2">
          <h1 className="display-4">Connexion</h1>
          <p className="lead">Connectez-vous avec votre courriel et mot de passe.</p>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
              {unverifiedHint && (
                <p className="mb-0 mt-2">
                  <button
                    type="button"
                    className="btn btn-link p-0 align-baseline"
                    onClick={handleResend}
                    disabled={resendLoading || !username}
                  >
                    {resendLoading ? 'Envoi...' : 'Renvoyer le courriel de vérification'}
                  </button>
                </p>
              )}
            </div>
          )}

          {resendMessage && (
            <div className="alert alert-success" role="alert">
              {resendMessage}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Courriel</label>
              <input
                type="email"
                className="form-control"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <div className="d-flex justify-content-between align-items-center">
                <label htmlFor="password" className="mb-0">Mot de passe</label>
                <Link to="/forgot-password" className="auth-inline-link">Mot de passe oublié?</Link>
              </div>
              <input
                type="password"
                className="form-control"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary btn-block auth-actions-btn" disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>

          <div className="auth-footer-links">
            <p>
              Pas encore de compte? <Link to="/signup">Créer un compte</Link>
            </p>
            <p>
              Compte Google existant? <Link to="/claim-account">Activer votre compte</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
